import $ from 'jquery';

import AssetPoller from './asset-poller';
import Confirmer from './confirm';

class Assets {


	
	constructor() {

		this.assets = [];
		this.trash = [];

		$(".asset").each((i, asset) => {
			if ($(asset).hasClass("deleted")) {
				this.trash.push(asset);
			} else {
				this.assets.push(asset);
			}
		});


		this.inTrash = false;

		$("#trashicon").click(e => {

			this.inTrash = !this.inTrash;
			this.display();

		});

		this.display();

		if ($(".asset.processing").length > 0) {
			let poller = new AssetPoller();
			poller.watch($(".asset.processing"));
		}
	}

	display() {
		let list = this.inTrash ? this.trash : this.assets;

		$("#assets-container").html("");
		let div = $("<div></div>").addClass("row");
		let items = 0;
		$(list).each((i, item) => {
			$(div).append(item);
			items++;
			if (items == 6) {
				$("#assets-container").append(div);
				div = $("<div></div>").addClass("row");
				items = 0;
			}
		});
		$("#assets-container").append(div);

		$("#assets-container .assetprevlink").each((i, link) => {
			$(link).click(e => {

				this.populateModal(link);

			});
		});
	}


	populateModal(asset) {

		let filename = $(asset).data("filename");
		let file = $(asset).data("file");
		let filesize = $(asset).data("size");
		let assetid = $(asset).data("id");
		let filetype = $(asset).data("icon");
		let typename = $(asset).data("typename");
		let status = $(asset).data("status");
		let video = $(asset).data("video");
		let audio = $(asset).data("audio");
		let title = $(asset).data("title");
		let preview = $(asset).data("preview");
		let media = $(asset).data("media");

		$("#share_url").html("");
        $("#video_preview").html("");
        $("#videoplaybutton").removeClass().unbind('click');
        $("#lowres").html("");

        $("#asset_title").html(title);
        
        var tp = $("<div></div>");
        $(tp).html( $("<span></span>").addClass("glyphicon").addClass("glyphicon-" + filetype) ).append(" " + typename);
       
        $("#p_type").html(tp);
        $("#p_filesize").html(filesize);
        $("#p_filename").html(filename);
        
        var self = this;
        $("#downloadasset").unbind("click").click(ee => {
        	ee.preventDefault();
        	window.open(file, "_blank");
        });

        
        $("#shareasset").unbind('click').click(ee => {
            ee.preventDefault();
            if ($("#share_url").html() == "") {
	            var input = $('<input type="text" class="form-control" />').val(file);
	            $("#share_url").html(input);
	            $(input).select();
	        } else {
	        	$("#share_url").html("");
	        }

        });
		
        $("#asset_preview").attr("src", preview).show();

        if (video) {
            
            $("#videoplaybutton").unbind("click").click(() => {
                var video = $('<video autoplay controls onclick="this.play();"></video>');
                var source = $('<source />').attr("src", media);
                $(video).html(source);

                $("#video_preview").html(video).show().removeClass().unbind("click");
            });

            $("#videoplaybutton").addClass("video").addClass("glyphicon").addClass("glyphicon-play");
            var a = $("<a></a>").addClass("btn").addClass("btn-info").html("Download Low Resolution").attr("target", "_blank").attr("href", media);
            $("#lowres").html(a);

        }

        if (audio) {
            
            $("#videoplaybutton").unbind("click").click(() => {
                var video = $('<audio autoplay controls></video>');
                var source = $('<source />').attr("src", media).attr("type", "audio/mpeg");
                $(video).html(source);

                $("#video_preview").html(video).show().removeClass().unbind("click");
            });
            $("#videoplaybutton").addClass("video").addClass("glyphicon").addClass("glyphicon-play");
        }


        $("#newsave").unbind('click').click((e) => {
	        e.preventDefault();

	        var orig = $("#asset_title").html();
	        var newt = $("#newname").val();

	        $("#asset_title").html(newt);
	        $.ajax({
	            data:{op:"setAssetTitle",id:assetid,title:newt},
	            success:function(d,s){
	                $("#asset" + assetid + " .panel-footer").html(newt);
	                $("#asset" + assetid + " a").data("title", newt);
	            }
	        });
	    
	        $("#asset_name_edit").hide();
	        $("#assetPreviewModalLabel").show();
	    });

        $("#adminassetdel").unbind('click').click((e) => {
            e.preventDefault();

            let danger = $("<div></div>").addClass("alert alert-danger").html("<p>Are you sure? <strong>You cannot undo</strong> this action</p>");

            (new Confirmer()).modal("Permanently Delete Asset?", danger, success => {

            	if (success) {
            		$.ajax({
            			data:{op:"permaDelete", id: assetid},
            			success: (d, s) => {
            				window.location.href = window.location.href; 
            			}

            		});
            	}

            });
        });

		$("#assetdel").unbind('click').click((e) => {
	        e.preventDefault();

	        let action = (status == 2) ? "restoreAsset" : "deleteAsset";
	        let message = (status == 2) ? "<p>Are you sure you want to restore this asset?</p>" : "<p>Are you sure you want to delete this asset?</p>";
	        let cls = status == 2 ? "alert-info" : "alert-danger";
	        
	        let danger = $("<div></div>").addClass("alert").addClass(cls).html(message);


	        (new Confirmer()).modal("Confirm", danger, success => {
	        	if (success) {
		            $.ajax({data:{op:action,id:assetid},
		                success:function(d,s){
		                    $("#assetPreviewModal").modal("hide");
		                    if (status == 2) {
		                        $("#asset" + assetid).removeClass("deleted").find(".assetprevlink").data("status", 0);
		                        $("#asset" + assetid).find(".glyphicon").remove();
		                    } else {
		                        $("#asset" + assetid).addClass("deleted").find(".assetprevlink").data("status", 2);
		                        $("#asset" + assetid).prepend('<span class="glyphicon glyphicon-trash"></span>');
		                    }
		                    
		                }
		            });
		        }
	        });

	    });

	    if (status == 2) {
            $("#assetdel").html("Restore").removeClass("btn-danger").addClass("btn-info");
        } else {
            $("#assetdel").html("Delete").removeClass("btn-info").addClass("btn-danger");
        }


	}

}

export default Assets;

